import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Projects from 'components/Projects';
import Overview from 'components/Overview';
import Details from "components/Details";
import Inspections from "components/Inspections";
import FieldTests from "components/FieldTests";
import Samples from "components/Samples";
import Contacts from "components/Contacts";
import Contracts from "components/Contracts";
import Forms from "components/Forms";
import Contractors from "components/Contractors";
import Checklist from "components/Checklist";
import WorkItemTracking from "components/WorkItemTracking";
import Observation from "components/Observation";
import WorkforceLabor from "components/WorkforceLabor";
import WeatherImpact from "components/WeatherImpact";
import Visitor from "components/Visitor";
import CommunicationEvent from "components/CommunicationEvent";
import WorkItems from './WorkItems';
import Resources from './Resources';
import Documents from './Documents';
import Issues from './Issues';
import Materials from './Materials';
import ProjectConfiguration from './ProjectConfiguration';
import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { useAppContext } from 'hooks/useAppContext';
import AuthRoute from './Shared/AuthRoute';
import Unauthorized from './Shared/Unauthorized';
import NotFound from './Shared/NotFound';
import AppBreadcrumbs from './Breadcrumbs';
import AdminConfig from './AdminConfig';
import Equipment from 'components/Equipment';
import Delays from 'components/Delays';
import Accident from 'components/Accidents';
import InspectionComments from 'components/InspectionComments';
import MaterialDelivery from 'components/MaterialDeliveries';
import Reports from 'components/Reports';

const useStyles = makeStyles(theme => ({
  drawer: {
    flexShrink: 0
  },
  drawerPaper: {
    width: theme.drawer.width,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(5),
    width: "calc(100% - 210px)"
  },
  contentWithoutDrawer: {
    flexGrow: 1,
    padding: theme.spacing(5),
    width: "100%"
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }
}));

// component to handle what is loaded via the main panel
// will probably use a reducer to handle project and module selection
const MainPanelLoader = () => {
  const classes = useStyles();
  const { drawerOpen } = useAppContext();

  return (
    <main className={!drawerOpen ? classes.contentWithoutDrawer : classes.content}>
      {/* add a div to account for app bar height */}
      <div className={classes.toolbar} />
      <AppBreadcrumbs />
      <Switch>
        <Route exact path="/unauthorized" component={Unauthorized} />
        <Route exact path="/notfound" component={NotFound} />
        <AuthRoute exact path="/projects/:projectId/overview" component={Overview} scope={"Overview"}/>
        {/* <AuthRoute exact path="/projects/:projectId/dashboard" component={Dashboard} scope={"Projects"}/> */}
        <AuthRoute exact path="/projects/:projectId" component={Details} scope={"Projects"}/>
        <AuthRoute exact path="/projects/:projectId/details" component={Details} scope={"Projects"}/>
        <AuthRoute exact path="/projects/:projectId/inspections" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/fieldtests" component={Inspections} scope={"Tests"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/samples" component={Inspections} scope={"Samples"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/equipment" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/delays" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/accidents" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/comments" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/deliveries" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/issues" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/checklist" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/workitemtracking" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/observation" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/workforcelabor" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/weatherimpact" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/visitor" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/inspections/:inspectionid/communicationevent" component={Inspections} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/contacts" component={Contacts} scope={"Contacts"}/>
        <AuthRoute exact path="/projects/:projectId/contracts" component={Contracts} scope={"Contracts"}/>
        <AuthRoute exact path="/projects/:projectId/workitems" component={WorkItems} scope={"WorkItems"}/>
        <AuthRoute exact path="/projects/:projectId/resources" component={Resources} scope={"Resources"}/>
        <AuthRoute exact path="/projects/:projectId/contractors" component={Contractors} scope={"Contractors"}/>
        <AuthRoute exact path="/projects/:projectId/checklist" component={Checklist} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/workitemtracking" component={WorkItemTracking} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/observation" component={Observation} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/workforcelabor" component={WorkforceLabor} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/weatherimpact" component={WeatherImpact} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/visitor" component={Visitor} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/communicationevent" component={CommunicationEvent} scope={"Inspections"}/>
        <AuthRoute exact path="/projects/:projectId/comments" component={InspectionComments} scope={"Comments"}/>
        <AuthRoute exact path="/projects/:projectId/fieldtests" component={FieldTests} scope={"Tests"}/>
        <AuthRoute exact path="/projects/:projectId/samples" component={Samples} scope={"Samples"}/>
        <AuthRoute exact path="/projects/:projectId/samples/:sampleid" component={Samples} scope={"Samples"}/>
        <AuthRoute exact path="/projects/:projectId/equipment" component={Equipment} scope={"Inspections"} />
        <AuthRoute exact path="/projects/:projectId/delays" component={Delays} scope={"Inspections"} />
        <AuthRoute exact path="/projects/:projectId/deliveries" component={MaterialDelivery} scope={"Inspections"} />
        <AuthRoute exact path="/projects/:projectId/accidents" component={Accident} scope={"Inspections"} />
        <AuthRoute exact path="/projects/:projectId/documents" component={Documents} scope={"Documents"}/>
        <AuthRoute exact path="/projects/:projectId/issues" component={Issues} scope={"Issues"}/>
        <AuthRoute exact path="/projects/:projectId/materials" component={Materials} scope={"Materials"}/>
        <AuthRoute exact path="/projects/:projectId/issues/:issuesid" component={Issues} scope={"Issues"}/>
        <AuthRoute exact path="/projects/:projectId/reports" component={Reports} scope={"Reports"}/>
        <AuthRoute exact path="/projects/:projectId/configuration" component={ProjectConfiguration} scope={"ProjectConfig"}/>
        <AuthRoute exact path="/MFSConfiguration" component={AdminConfig} scope={"AdminConfig"} />
        <Route exact path="/projects">
          <Projects></Projects>
        </Route>
        <Route exact path="/Forms">
          <Forms></Forms>
        </Route>
        <Route exact path="/">
          <Projects></Projects>
        </Route>
        <Route render={() => <Redirect to="/notfound" />} />
      </Switch>
    </main>
  )
}

export default MainPanelLoader;

